interface CheckExpiredProps {
  label?: string;
  heading?: string;
}

export const CheckExpiredMessage = ({
  heading = "404",
  label = "Page Not Found",
}: CheckExpiredProps) => {
  return (
    <div className="flex flex-col items-center justify-center grid grid-cols-2 gap-x-4">
      <div>
        <img alt="work right" src="/images/wr_logo.png" />
      </div>
      <div>
        <h1 className="text-black font-inter text-7xl font-normal leading-normal">
          {heading}
        </h1>
        <h3 className="text-black font-inter text-2xl font-bold leading-normal">
          {label}
        </h3>
        {label === "Check has been submitted" ? <p className="text-black font-inter  font-normal leading-normal mt-1">
          A Right to Work check has already been submitted, please contact <a href="mailto:WorkRight@fragomen.com" style={{ all: "revert" }}>WorkRight@fragomen.com</a> if further assistance is required.
        </p> : (
          <>
        <p className="text-black font-inter  font-normal leading-normal mt-1">
          We could not find any details for the provided check. The link may be
          invalid or expired.
        </p>
        <p className="text-black font-inter  font-normal leading-normal mt-3">
          Please ensure the URL is correct, or contact support if the issue
          persists.
        </p>
        </>
          )}
        
      </div>
    </div>
  );
};
